import homePage from "./alternativeHomepage"
export default homePage
